const path = (resource) => {
  if (!resource) resource = '';
  return { resource: 'api/subscriptions/' + resource };
};

export const getTrialEligibility = (companyId) => {
  return (dispatch, getState, api) => {
    return api.get(path(`eligible_for_trial?company_id=${companyId}`));
  };
};

export const getSubscriptionPlans = () => {
  return (dispatch, getState, api) => {
    return api.get({ resource: 'api/subscription_plans' });
  };
};

export const createSubscription = (companyId, planType) => {
  return (dispatch, getState, api) => {
    return api.post(path(), {
      company_id: companyId,
      plan_type: planType,
    });
  };
};
